import { env } from '../env';

const TIMEOUTS: Record<string, number> = {
  local: 10000,
  development: 10000,
  staging: 15000,
  production: 20000,
};

export const getApiConfig = () => {
  console.log('🔧 API Config:', { apiEnv: env.apiEnv, baseURL: env.apiUrl });
  return {
    baseURL: env.apiUrl,
    timeout: TIMEOUTS[env.apiEnv] ?? 10000,
  };
};

